const initialState = {
  'byId': new Map(),
};

export function customersReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_CUSTOMERS':
      return {
      ...state,
      byId: new Map([...state.byId, ...action.payload]),
    };
    default:
      return state;
  }
}
